import { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import SortArrows from "../../src/assets/svg/sortArrows.svg";
import ButtonComplex from "./ButtonComplex";
import React from "react";
import { useSearchParams } from "react-router-dom";

export interface SortProps {
  className?: string;
  sortOptions: Record<string, string>;
  onSortApply?: (filters: Record<string, string[]>) => void;
}

export function Sort({ className, sortOptions, onSortApply }: SortProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [searchParams, setSearchParams] = useSearchParams(); // Dodano za upravljanje URL parametrima

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  // const handleSelect = (option: string) => {
  //   const sortValue = sortOptions[option]; // Get sorting value from sortOptions
  
  //   // Extract existing filters from searchParams
  //   const updatedFilters = Object.fromEntries(searchParams.entries());
  //   const filters: Record<string, string[]> = {};
  
  //   // Transform existing parameters back into filters
  //   for (const [key, value] of Object.entries(updatedFilters)) {
  //     if (key !== "page" && key !== "sort") {
  //       filters[key] = value.split(",");
  //     }
  //   }
  
  //   // Ensure "Raspon cijene" is preserved in searchParams
  //   if (filters["Raspon cijene"]) {
  //     updatedFilters["Raspon cijene"] = filters["Raspon cijene"].join(",");
  //   }
  
  //   // Add sort parameter to filters
  //   if (sortValue) {
  //     updatedFilters.sort = sortValue; // Update sort in URL
  //   } else {
  //     delete updatedFilters.sort; // Remove sort if default is selected
  //   }
  
  //   updatedFilters.page = "1"; // Reset to page 1 on sort
  
  //   // Update searchParams in the URL
  //   setSearchParams(updatedFilters);
  
  //   // Trigger onSortApply if provided (for external handling)
  //   if (onSortApply) {
  //     onSortApply(filters);
  //   }
  
  //   setIsOpen(false); // Close dropdown
  // };
  
  

  // Close dropdown when clicking outside
  
  const handleSelect = (option: string) => {
    const sortValue = sortOptions[option];
    const updatedFilters = Object.fromEntries(searchParams.entries());
  
    // Preserve the price range filter
    if (updatedFilters.rasponcijene) {
      updatedFilters.rasponcijene = updatedFilters.rasponcijene;
    }
  
    if (sortValue) {
      updatedFilters.sort = sortValue;
    } else {
      delete updatedFilters.sort;
    }
  
    updatedFilters.page = "1"; // Reset to the first page
    setSearchParams(updatedFilters);
  
    // Notify the parent component
    if (onSortApply) {
      const filters = Object.entries(updatedFilters).reduce((acc, [key, value]) => {
        acc[key] = value.split(",");
        return acc;
      }, {} as Record<string, string[]>);
      onSortApply(filters);
    }
    setIsOpen(false);
  };
  
  
  
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {/* Sort icon button */}
      <div className={clsx("relative", className)} ref={dropdownRef}>
        <ButtonComplex
          label="Sortirajte"
          className={clsx(className, "flex")}
          icon={
            <img src={SortArrows} alt="Sort" className="w-3.5 h-[12.77px]" />
          }
          onClick={toggleDropdown}
        ></ButtonComplex>

        {/* Dropdown Menu */}
        {isOpen && (
          <div className="absolute left-0 z-10 w-full mt-2 overflow-y-auto text-xs bg-white border rounded shadow-lg border-extra-light max-h-52 text-filter-gray">
            {Object.keys(sortOptions).map((option) => (
              <label
                key={option}
                onClick={() => handleSelect(option)}
                className="flex items-center justify-between px-3 py-2 cursor-pointer hover:bg-gray-100"
              >
                <span>{option}</span>
              </label>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

export default Sort;
